// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list_lF6gl > .listItem_DMHLA {
  color: var( --color-base700 );
  border: 1px solid transparent;
  padding: 8px var( --size-padLarge );
  font-size: var( --size-fontBodySmall );
  font-weight: 600;
  background-color: var( --color-white );
}
.list_lF6gl > .listItem_DMHLA:hover {
  background-color: var( --color-brand050 );
}
.list_lF6gl > .listItem_DMHLA[data-list-item-selected=true] {
  background-color: var( --color-brand100 );
}
.list_lF6gl > .listItem_DMHLA[data-disabled] {
  color: var( --color-base500 );
  background-color: var( --color-base050 );
}
.list_lF6gl.list-dataListItem_gNjDH > .listHeader_IOkkd {
  font: 13px/20px Inter;
  color: var( --color-base500 );
  padding: var( --size-padMedium ) var( --size-padMedium ) var( --size-padMedium ) var( --size-medium );
  overflow: hidden;
  white-space: nowrap;
  text-overflow: clip;
  text-transform: uppercase;
}
.list_lF6gl.list-dataListItem_gNjDH > .listItem_DMHLA {
  font: normal 12px/var( --size-large ) Inter;
  color: #394756;
  overflow: hidden;
  white-space: nowrap;
  padding-top: var( --size-padMedium );
  text-overflow: clip;
  border-bottom: 1px solid var( --color-base100 );
  padding-bottom: var( --size-padMedium );
}
.list_lF6gl.list-mobileDetail_x__bz > .listItem_DMHLA {
  padding: 0px;
}
.list_lF6gl.list-mobileDetail_x__bz > .listItem_DMHLA:nth-child(odd) {
  background-color: var( --color-brand050 );
}
.list_lF6gl.list-groupData_F7Pwt > .listItem_DMHLA {
  padding: 0px;
}
.list_lF6gl.list-dataListItem_gNjDH.list-detailItem_nUMmG > .listItem_DMHLA {
  padding-top: var( --size-padSmall );
  border-bottom: 1px solid var( --color-base100 );
  padding-bottom: var( --size-padSmall );
  background-color: transparent;
}
.list_lF6gl.list-dataListItem_gNjDH.list-detailItem_nUMmG > .listItem_DMHLA:nth-child(even) {
  background-color: var( --color-white );
}
.list_lF6gl.list-dataListItem_gNjDH.list-detailItem_nUMmG > .listItem_DMHLA:nth-child(odd) {
  background-color: var( --color-white );
}
.list_lF6gl.list-mobileSuggestions_D0rlj > .listItem_DMHLA {
  padding: var( --size-padLarge );
  font-weight: normal;
  border-bottom: 1px solid var( --color-base100 );
}
.list_lF6gl.list-suggestions_mIWwg > .listItem_DMHLA {
  font-weight: normal;
}
.list_lF6gl.list-pairing_phOXv > .listHeader_IOkkd {
  color: var( --color-base700 );
  font-size: var( --size-fontBodySmall );
  font-weight: 500;
}
.list_lF6gl.list-pairing_phOXv > .listItem_DMHLA {
  padding: var( --size-padLarge ) 0px;
  border-bottom: 1px solid var( --color-base200 );
}
.list_lF6gl.list-pairing_phOXv > .listItem_DMHLA:hover {
  border-radius: 2px;
  background-color: var( --color-base050 );
}
.list_lF6gl.list-pairing_phOXv > .listItem_DMHLA[data-list-item-selected=true] {
  background-color: transparent;
}
.list_lF6gl.list-pairing_phOXv > .listItem_DMHLA:last-child {
  border: none;
}
.list_lF6gl.list-operatingHoursOverrides_PjlJ5 > .listItem_DMHLA {
  border-top: 1px solid var( --color-base100 );
}
.list_lF6gl.list-operatingHoursOverrides_PjlJ5 > .listItem_DMHLA:first-child {
  border-top: none;
}
.list_lF6gl.list-operatingHoursOverrides_PjlJ5 > .listItem_DMHLA:last-child {
  border-bottom: 1px solid var( --color-base100 );
}
.list_lF6gl.list-pairingItem_dnSg3 > .listItem_DMHLA {
  padding: var( --size-padLarge ) 0px;
  border-bottom: 1px solid var( --color-base200 );
}
.list_lF6gl.list-pairingItem_dnSg3 > .listItem_DMHLA:last-child {
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/theme/List.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,mCAAmC;EACnC,sCAAsC;EACtC,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,6BAA6B;EAC7B,wCAAwC;AAC1C;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,qGAAqG;EACrG,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,2CAA2C;EAC3C,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,+CAA+C;EAC/C,uCAAuC;AACzC;AACA;EACE,YAAY;AACd;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,YAAY;AACd;AACA;EACE,mCAAmC;EACnC,+CAA+C;EAC/C,sCAAsC;EACtC,6BAA6B;AAC/B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,+CAA+C;AACjD;AACA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,mCAAmC;EACnC,+CAA+C;AACjD;AACA;EACE,YAAY;AACd","sourcesContent":[".list > .listItem {\n  color: var( --color-base700 );\n  border: 1px solid transparent;\n  padding: 8px var( --size-padLarge );\n  font-size: var( --size-fontBodySmall );\n  font-weight: 600;\n  background-color: var( --color-white );\n}\n.list > .listItem:hover {\n  background-color: var( --color-brand050 );\n}\n.list > .listItem[data-list-item-selected=true] {\n  background-color: var( --color-brand100 );\n}\n.list > .listItem[data-disabled] {\n  color: var( --color-base500 );\n  background-color: var( --color-base050 );\n}\n.list.list-dataListItem > .listHeader {\n  font: 13px/20px Inter;\n  color: var( --color-base500 );\n  padding: var( --size-padMedium ) var( --size-padMedium ) var( --size-padMedium ) var( --size-medium );\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: clip;\n  text-transform: uppercase;\n}\n.list.list-dataListItem > .listItem {\n  font: normal 12px/var( --size-large ) Inter;\n  color: #394756;\n  overflow: hidden;\n  white-space: nowrap;\n  padding-top: var( --size-padMedium );\n  text-overflow: clip;\n  border-bottom: 1px solid var( --color-base100 );\n  padding-bottom: var( --size-padMedium );\n}\n.list.list-mobileDetail > .listItem {\n  padding: 0px;\n}\n.list.list-mobileDetail > .listItem:nth-child(odd) {\n  background-color: var( --color-brand050 );\n}\n.list.list-groupData > .listItem {\n  padding: 0px;\n}\n.list.list-dataListItem.list-detailItem > .listItem {\n  padding-top: var( --size-padSmall );\n  border-bottom: 1px solid var( --color-base100 );\n  padding-bottom: var( --size-padSmall );\n  background-color: transparent;\n}\n.list.list-dataListItem.list-detailItem > .listItem:nth-child(even) {\n  background-color: var( --color-white );\n}\n.list.list-dataListItem.list-detailItem > .listItem:nth-child(odd) {\n  background-color: var( --color-white );\n}\n.list.list-mobileSuggestions > .listItem {\n  padding: var( --size-padLarge );\n  font-weight: normal;\n  border-bottom: 1px solid var( --color-base100 );\n}\n.list.list-suggestions > .listItem {\n  font-weight: normal;\n}\n.list.list-pairing > .listHeader {\n  color: var( --color-base700 );\n  font-size: var( --size-fontBodySmall );\n  font-weight: 500;\n}\n.list.list-pairing > .listItem {\n  padding: var( --size-padLarge ) 0px;\n  border-bottom: 1px solid var( --color-base200 );\n}\n.list.list-pairing > .listItem:hover {\n  border-radius: 2px;\n  background-color: var( --color-base050 );\n}\n.list.list-pairing > .listItem[data-list-item-selected=true] {\n  background-color: transparent;\n}\n.list.list-pairing > .listItem:last-child {\n  border: none;\n}\n.list.list-operatingHoursOverrides > .listItem {\n  border-top: 1px solid var( --color-base100 );\n}\n.list.list-operatingHoursOverrides > .listItem:first-child {\n  border-top: none;\n}\n.list.list-operatingHoursOverrides > .listItem:last-child {\n  border-bottom: 1px solid var( --color-base100 );\n}\n.list.list-pairingItem > .listItem {\n  padding: var( --size-padLarge ) 0px;\n  border-bottom: 1px solid var( --color-base200 );\n}\n.list.list-pairingItem > .listItem:last-child {\n  border: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `list_lF6gl`,
	"listItem": `listItem_DMHLA`,
	"list-dataListItem": `list-dataListItem_gNjDH`,
	"listHeader": `listHeader_IOkkd`,
	"list-mobileDetail": `list-mobileDetail_x__bz`,
	"list-groupData": `list-groupData_F7Pwt`,
	"list-detailItem": `list-detailItem_nUMmG`,
	"list-mobileSuggestions": `list-mobileSuggestions_D0rlj`,
	"list-suggestions": `list-suggestions_mIWwg`,
	"list-pairing": `list-pairing_phOXv`,
	"list-operatingHoursOverrides": `list-operatingHoursOverrides_PjlJ5`,
	"list-pairingItem": `list-pairingItem_dnSg3`
};
export default ___CSS_LOADER_EXPORT___;
